export default function initHeader() {
  const header = document.getElementById('header');
  const menuToggle = document.querySelector('#menuToggle');
  const mobileMenu = document.querySelector('.header__mobile');

  let scrollY = 0;

  /** Exit early if required elements don't exist */
  if (!header || !menuToggle || !mobileMenu) return;

  /** Scroll behaviour */
  const handleScroll = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 10);
  };

  window.addEventListener('scroll', handleScroll);

  /** Run once on load in case page is already scrolled */
  handleScroll();

  /** Menu toggle */
  if (menuToggle) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.classList.toggle('active');
      mobileMenu.classList.toggle('active', isOpen);

      if (isOpen) {
        scrollY = window.scrollY;

        document.body.style.top = `-${scrollY}px`;
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
        document.body.style.top = '';

        window.scrollTo(0, scrollY);
      }
    });
  }
}
